import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import CircularProgress from 'material-ui/CircularProgress';
import marked from 'marked';
import ReactPlayer from 'react-player';

import { closeHelpWidget } from '../../stores/ui/components/helpwidget/helpwidget-actions';

const styles = {
  title: {
    '&>h1': {
      fontSize: '18px !important',
    },
  },
  content: {
    padding: '20px',
    '&>span>h4': {
      fontSize: '16px !important',
    },
    '&>p>*, &>span>*': {
      color: '#616061 !important',
      '&>li': {
        fontSize: '13px',
      },
    },
    '&>span>p>ul, &>span>p>ol': {
      paddingLeft: '20px !important',
    },
  },
  loading: {
    opacity: '0.3',
    filter: 'blur(5px)',
  },
  circularProgress: {
    left: '142px',
    position: 'absolute !important',
    top: '200px',
  },
};

class HelpDrawer extends Component {
  closeSidebar = () => {
    this.props.closeHelpWidget();
  }
  render() {
    const {
      classes,
      help: {
        description,
        onThisPage,
        title,
        terminology,
        suggestedActions,
        videoUrl,
      },
      isOpen,
      loading,
    } = this.props;

    return (
      <Drawer width={394} openSecondary open={isOpen} containerStyle={{ zIndex: '3300' }} >
        { loading ? <CircularProgress size={80} thickness={5} className={classes.circularProgress}/> : undefined}
        <AppBar
          className={classes.title}
          title={loading ? '...' : title}
          showMenuIconButton={false}
          iconElementRight={<IconButton><NavigationClose /></IconButton>}
          onRightIconButtonTouchTap={this.closeSidebar}
        />
        <div className={`${classes.content}${loading ? ` ${classes.loading}` : ''}`}>
          <p dangerouslySetInnerHTML={{ __html: marked(description) }}></p>
          {videoUrl ? <ReactPlayer
            url={videoUrl}
            width="339px"
            height="188px"
          /> : null}
          {(onThisPage.length > 0) ? <span>
            <h4>On this page</h4>
            {onThisPage.map(({ id, displayText, url }) => (<li key={id}>
              <a href={url} target="_blank" style={{ textDecoration: 'none' }}>{displayText}</a>
            </li>))}
          </span> : null}
          {terminology ? <span>
            <h4>Terminology</h4>
            <p dangerouslySetInnerHTML={{ __html: marked(terminology) }}></p>
          </span> : null}
          {suggestedActions ? <span>
            <h4>Suggested Actions</h4>
            <p dangerouslySetInnerHTML={{ __html: marked(suggestedActions) }}></p>
          </span> : null}
        </div>
      </Drawer>
    );
  }
}

HelpDrawer.defaultProps = {
  help: {
    title: '',
    description: '',
    onThisPage: [],
    terminology: undefined,
    videoUrl: undefined,
  },
  loading: true,
  isOpen: false,
};

HelpDrawer.propTypes = {
  classes: PropTypes.object,
  help: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  closeHelpWidget: PropTypes.func,
};

export default connect(({ ui, sidebarHelp }) => ({
  loading: sidebarHelp.contentLoading,
  help: sidebarHelp.helpArticle,
  isOpen: ui.helpwidget.get('isOpen'),
}), {
  closeHelpWidget,
})(injectSheet(styles)(HelpDrawer));



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/help-drawer.jsx